module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "header-wrap-sticky"
  }, [_c('div', {
    staticClass: "header-wrap-inner"
  }, [_c('li', {
    staticClass: "header-left-2"
  }, [(_vm.path_name == 'Product') ? _c('span', [_c('a', {
    staticClass: "header-nav-back",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "8px",
      "color": "#000000",
      "font-size": "20px",
      "font-weight": "500",
      "cursor": "pointer",
      "text-decoration": "none"
    }
  }, [_vm._v(_vm._s(_vm.product_name))])]) : _c('span', [_c('a', {
    staticStyle: {
      "color": "#000000",
      "font-size": "20px",
      "font-weight": "500",
      "cursor": "pointer",
      "text-decoration": "none"
    },
    attrs: {
      "href": "/"
    }
  }, [_c('logo-pad'), _c('span', {
    staticStyle: {
      "margin-left": "8px"
    }
  }, [_vm._v(_vm._s(_vm.path))])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "header-right-2"
  }, [_c('ul', [(_vm.path_name == 'Product') ? _c('li', [_c('a', {
    staticStyle: {
      "font-size": "22px",
      "font-weight": "400",
      "color": "#ff0066"
    },
    attrs: {
      "href": '/' + _vm.sellpoint_name
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })])]) : _c('li', [_vm._m(0)]), _vm._v(" "), _c('li', [_c('component-account-menu')], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/buzz"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "28px",
      "margin-top": "-7px"
    },
    attrs: {
      "src": "/static/assets/images/buzzer_k.gif"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a5a55fe"}!./src/pages/AppCommat/Template/template.html
// module id = 396
// module chunks = 0